import axios from "axios";
import {
  GET_ALL_BALANCE_SHEET,
} from "../../../config/config";
import { IAPIPayload } from "../../../interfaces/apiInterface";

export const getAllBalanceSheetList = (data: IAPIPayload) => {
  return axios.post(GET_ALL_BALANCE_SHEET, data);
};
